import './caroussel.css'
import { Link } from 'react-router-dom'
import ImageEleve from './images/eleve1.jpg'
import Inscription from './images/inscription.jpg'
import Suivi from './images/suiviacademique.jpg'
import Communication from './images/communicationefficace.webp'
import Ressourc from './images/gestiondesressources.jpg'
import Planification from './images/planificationcours.jpg'
import Support from './images/supporttechnique.jpg'
import Utilisateur from './images/utilisateur.avif'
import { Carousel } from 'react-bootstrap'


function Corpmonecole(){
const testimonials = [
    { name: "Jean Dupont", role: "Directeur", text: "Mon Ecole a transformé la façon dont nous gérons notre établissement." },
    { name: "Marie Curie", role: "Enseignante", text: "La communication avec les parents est devenue beaucoup plus facile." },
    { name: "Paul Martin", role: "Élève", text: "J'adore la facilité d'accès à mes informations académiques." },
    { name: "Sophie Mwamba", role: "Parent d'élève", text: "Le support technique de Mon Ecole est exceptionnel." },
    { name: "Claire Atosha", role: "Directrice des études", text: "Mon Ecole a vraiment amélioré la gestion des ressources." },
    { name: "Lucas Mahajabu", role: "Enseignant", text: "Je recommande vivement Mon Ecole à toutes les institutions." }
];
const chunkedTestimonials = [];
for (let i = 0; i < testimonials.length; i += 3) {
    chunkedTestimonials.push(testimonials.slice(i, i + 3));
}
const Handleprev=()=>{
    var slides=document.querySelectorAll(".slide")
var nbrslides=slides.length
    if(slides){
        const tabslides=[...slides]
        const activ=document.querySelector(".slide.active")
        var indexslide=tabslides.indexOf(activ)
        if(indexslide>0){
            indexslide=indexslide-1
        }
        else{
            indexslide=nbrslides-1
        }
        activ.classList.remove("active")
      
        tabslides[indexslide].classList.add("active")
    }
        
    }
const Handlenext=()=>{
    var slides=document.querySelectorAll(".slide")
var nbrslides=slides.length
    if(slides){
        const tabslides=[...slides]
        const activ=document.querySelector(".slide.active")
    
        var indexslide=tabslides.indexOf(activ)
        if(indexslide<nbrslides-1){
            indexslide=indexslide+1
        }
        else{
            indexslide=0
        }
        activ.classList.remove("active")
        tabslides[indexslide].classList.add("active")
        }
    }

    return(
        <>
      <main>
       <section class="py-5 bg-light">
        <div class="container">
            <div class="row align-items-center gy-4">
                <div class="col-lg-6">
                    <h4 class="display-4 fw-bold text-primary mb-3">
                        La numérisation et la digitalisation de votre école sont bien assurés sur Mon école
                    </h4>
                    <p class="lead text-muted mb-4">
                        Simplifiez la gestion de votre établissement scolaire avec Mon Ecole, la plateforme tout-en-un pour une administration efficace et une communication fluide.
                    </p>
                    <Link to="/register" class="btn btn-primary btn-lg px-5 shadow-sm">
                        Rejoignez-nous
                    </Link>
                </div>
                <div class="col-lg-6 text-center">
                    <img src={ImageEleve} alt="Élève utilisant Mon Ecole" class="img-fluid rounded-3 shadow" />
                </div>
            </div>
        </div>
    </section>
    <section class="py-5">
        <div class="container text-center">
            <div class="mb-5">
                <h2 class="fw-bold">Nos domaines d'expertise</h2>
                <p class="text-muted mx-auto" style={{maxWidth: "700px;"}}>Découvrez comment Mon Ecole peut transformer la gestion de votre établissement scolaire grâce à nos solutions innovantes.</p>
            </div>
        <div className="row g-4">
            {[
                { img: Inscription, title: "Gestion des inscriptions", desc: "Facilitez le processus d'inscription en ligne." },
                { img: Suivi, title: "Suivi académique", desc: "Suivez les performances académiques des étudiants." },
                { img: Communication, title: "Communication efficace", desc: "Améliorez la communication entre enseignants et parents." },
                { img: Ressourc, title: "Gestion des ressources", desc: "Optimisez l'utilisation des ressources scolaires." },
                { img: Planification, title: "Planification des cours", desc: "Organisez et planifiez les cours de manière efficace." },
                { img: Support, title: "Support technique", desc: "Bénéficiez d'un support technique dédié." },
                // ... (vos autres items)
            ].map((item, index) => (
                <div className="col-md-6 col-lg-4" key={index}>
                    <div 
                        className="card h-100 border-0 shadow-sm p-3"
                        style={{ 
                            transition: 'transform 0.3s ease, shadow 0.3s ease',
                            cursor: 'pointer'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'translateY(-10px)';
                            e.currentTarget.className = 'card h-100 border-0 shadow p-3';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.className = 'card h-100 border-0 shadow-sm p-3';
                        }}
                    >
                        <img src={item.img} className="card-img-top mx-auto mt-3" style={{ width: '60px' }} alt={item.title} />
                        <div className="card-body text-center">
                            <h5 className="card-title fw-bold">{item.title}</h5>
                            <p className="card-text text-muted small">{item.desc}</p>
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
   
   
    <section class="py-5 bg-dark text-white">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-6">
                    <h2 class="fw-bold mb-4">À propos de Mon Ecole</h2>
                    <p class="opacity-75">
                        Mon Ecole est une plateforme innovante dédiée à la gestion numérique des établissements scolaires. 
                        Notre mission est de simplifier les processus administratifs et académiques grâce à notre technologie avancée.
                    </p>
                </div>
                <div class="col-lg-6">
                    <div class="card bg-white text-dark p-4 shadow">
                        <h2 class="fw-bold mb-4 h4 text-center">Contactez-nous</h2>
                        <form>
                            <div class="mb-3">
                                <label class="form-label">Nom</label>
                                <input type="text" class="form-control" placeholder="Votre nom" required />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Email</label>
                                <input type="email" class="form-control" placeholder="exemple@mail.com" required />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Message</label>
                                <textarea class="form-control" rows="3" placeholder="Votre message..."></textarea>
                            </div>
                            <button type="submit" class="btn btn-primary w-100">Envoyer</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="py-5 bg-light">
    <div className="container text-center">
        <h2 className="fw-bold mb-5">Témoignages</h2>

        <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner px-md-5">
                
                {/* --- GROUPE 1 --- */}
                <div className="carousel-item active">
                    <div className="row g-4 justify-content-center">
                        
                        {/* Carte 1 : Toujours visible (Mobile, Tablette, PC) */}
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Jean Dupont</h6>
                                <p className="text-muted fst-italic small">"Mon Ecole a transformé notre gestion."</p>
                            </div>
                        </div>

                        {/* Carte 2 : Cachée sur Mobile, Visible sur Tablette (md) et PC (lg) */}
                        <div className="col-md-6 col-lg-4 d-none d-md-block">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Marie Curie</h6>
                                <p className="text-muted fst-italic small">"Communication simplifiée avec les parents."</p>
                            </div>
                        </div>

                        {/* Carte 3 : Cachée sur Mobile et Tablette, Visible UNIQUEMENT sur PC (lg) */}
                        <div className="col-lg-4 d-none d-lg-block">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Paul Martin</h6>
                                <p className="text-muted fst-italic small">"Accès facile aux ressources académiques."</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* --- GROUPE 2 (Même logique pour les 3 suivants) --- */}
                <div className="carousel-item">
                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Sophie Mwamba</h6>
                                <p className="text-muted fst-italic small">"Le support technique est exceptionnel."</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 d-none d-md-block">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Claire Atosha</h6>
                                <p className="text-muted fst-italic small">"Efficacité améliorée pour nos ressources."</p>
                            </div>
                        </div>
                        <div className="col-lg-4 d-none d-lg-block">
                            <div className="card h-100 border-0 shadow-sm p-4 mx-1">
                                <img src={Utilisateur} className="rounded-circle mx-auto mb-3" style={{width: '65px'}} alt="avatar" />
                                <h6 className="fw-bold mb-1">Lucas Mahajabu</h6>
                                <p className="text-muted fst-italic small">"Je recommande vivement cette plateforme."</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Boutons de navigation (positionnés sur les côtés) */}
            <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev" style={{width: '5%'}}>
                <span className="btn btn-dark btn-sm rounded-circle shadow" aria-hidden="true">❰</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next" style={{width: '5%'}}>
                <span className="btn btn-dark btn-sm rounded-circle shadow" aria-hidden="true">❱</span>
            </button>
        </div>
    </div>
</section>


   {/* Section Témoignages Mise à jour 
    <section class="py-5 bg-light">
        <div class="container text-center">
            <h2 class="fw-bold mb-5">Témoignages</h2>
            
           // Utilisation d'une grille Bootstrap pour les témoignages 
            <div class="row g-4 justify-content-center">
                {[
                    { name: "Jean Dupont", role: "Directeur", text: "Mon Ecole a transformé la façon dont nous gérons notre établissement." },
                    { name: "Marie Curie", role: "Enseignante", text: "La communication avec les parents est devenue beaucoup plus facile." },
                    { name: "Paul Martin", role: "Élève", text: "J'adore la facilité d'accès à mes informations académiques." },
                    { name: "Sophie Mwamba", role: "Parent d'élève", text: "Le support technique de Mon Ecole est exceptionnel. Ils sont toujours prêts à aider." },
                    { name: "Claire Atosha", role: "Directrice des études", text: "Mon Ecole a vraiment amélioré l'efficacité de notre gestion des ressources." },
                    { name: "Lucas Mahajabu", role: "Enseignant", text: "Je recommande vivement Mon Ecole à toutes les institutions éducatives." }
                ].map((testi, index) => (
                    <div class="col-md-6 col-lg-4" key={index}>
                        <div class="card h-100 border-0 shadow-sm p-4 position-relative">
                            <img 
                                src={Utilisateur} 
                                class="rounded-circle mx-auto mb-3" 
                                style={{ width: '70px', height: '70px', objectFit: 'cover' }} 
                                alt="avatar" 
                            />
                            <h5 class="fw-bold mb-1">{testi.name}</h5>
                            <span class="badge bg-primary-subtle text-primary mb-3 mx-auto" style={{ width: 'fit-content' }}>
                                {testi.role}
                            </span>
                            <p class="text-muted fst-italic">"{testi.text}"</p>
                            <button class="btn btn-outline-primary btn-sm rounded-circle mx-auto" style={{ width: '35px', height: '35px' }}>→</button>
                        </div>
                    </div>
                ))}
            </div>

            // Contrôles de navigation (si vous implémentez un vrai slider JS plus tard) 
            <div class="mt-4 d-flex justify-content-center gap-3">
                <button class="btn btn-dark rounded-circle" onClick={Handleprev}>❰</button>
                <button class="btn btn-dark rounded-circle" onClick={Handlenext}>❱</button>
            </div>
        </div>
    </section>
*/}
    {/* Section Call-to-Action (CTA) */}
    <section class="py-5 bg-primary text-white text-center">
        <div class="container">
            <div class="py-4">
                <h2 class="display-5 fw-bold mb-3">Rejoignez Mon Ecole dès aujourd'hui !</h2>
                <p class="lead mb-4 opacity-75">
                    Inscrivez-vous gratuitement maintenant et découvrez comment Mon Ecole peut transformer la gestion de votre établissement scolaire.
                </p>
                <Link to="/register">
                    <button class="btn btn-light btn-lg px-5 py-3 fw-bold text-primary shadow">
                        Rejoignez-nous
                    </button>
                </Link>
            </div>
        </div>
    </section>
</main>
</>
    )
}
export default Corpmonecole